import * as Blockly from "blockly";

export class FieldIconBase extends Blockly.Field<string> {
  public static SERIALIZABLE = true;
  public override SERIALIZABLE = true;

  public static override fromJson<T extends FieldIconBase>(
    this: new (iconClass?: string) => T,
    options: Blockly.FieldConfig & { icon?: string },
  ): T {
    return new this(options.icon ?? "ri-question-line");
  }

  constructor(iconClass: string = "ri-question-line") {
    super(iconClass);
  }

  protected override doClassValidation_(newValue?: string): string | null {
    return typeof newValue === "string" ? newValue : null;
  }

  public setIcon(iconClass: string): void {
    this.setValue(iconClass);
  }
}
